import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchContacts } from "./asyncActions";
import { IContactsState, IContactsData } from "./types";

const initialState: IContactsState = {
  isLoading: false,
  contacts: null,
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchContacts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      fetchContacts.fulfilled,
      (state, action: PayloadAction<IContactsData | null>) => {
        state.isLoading = false;
        state.contacts = action.payload;
      }
    );
    builder.addCase(fetchContacts.rejected, (state) => {
      state.isLoading = false;
      state.contacts = null;
    });
  },
});

export default contactsSlice.reducer;

